import { Box, styled } from '@mui/material'

export const TestimonialContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',
  justifyContent: 'center',
}))

export const TestimonialImageContainer = styled(Box)(() => ({
  width: '48px',
  height: '48px',
  position: 'relative',
  borderRadius: '24px',
  overflow: 'hidden',
}))
